import unityPlayerApi from "../../../unity-player/player-api/api";
import { useBoundStore } from "../../../zustand/store";

const useHomeController = () => {
  const buildingID: string = "101719"; // * just some random ID
  const playerAssetsConfig = {
    baseUrl: process.env.REACT_APP_SNACK_VIEWER_BASE_URL,
    loaderUrl: process.env.REACT_APP_SNACK_VIEWER_LOADER_URL,
    dataUrl: process.env.REACT_APP_SNACK_VIEWER_DATA_URL,
    frameworkUrl: process.env.REACT_APP_SNACK_VIEWER_FRAMEWORK_URL,
    codeUrl: process.env.REACT_APP_SNACK_VIEWER_CODE_URL,
    streamingAssetsUrl: process.env.REACT_APP_SNACK_VIEWER_STREAMING_ASSETS_URL_PATH,
  };

  // @ts-ignore
  const { unityPlayerInstance } = useBoundStore((state) => state);

  const setModelConfig = (
    unityInstance: any,
    buildingID: string | undefined
  ) => {
    unityPlayerApi.sendMessage(unityInstance, {
      gameObjectName: "FrontEndInteractionManager",
      gameObjectMethodName: "SetModelConfig",
      value: JSON.stringify({ buildingID, viewerDataFetchBaseUrl: process.env.REACT_APP_SNACK_VIEWER_DATA_FETCH_BASE_URL }),
    });
  };

  const setHeatMapFeature = () => {
    unityPlayerApi.sendMessage(unityPlayerInstance, {
      gameObjectName: "FrontEndInteractionManager",
      gameObjectMethodName: "SetActiveFeature",
      value: JSON.stringify({ featureKey: "HEATMAP" }),
    });
  };

  const setGlassPanelsTintStatusFeature = () => {
    unityPlayerApi.sendMessage(unityPlayerInstance, {
      gameObjectName: "FrontEndInteractionManager",
      gameObjectMethodName: "SetActiveFeature",
      value: JSON.stringify({ featureKey: "TINT_STATUS" }),
    });
  };

  const setGlassPanelsPolarizationFeature = () => {
    unityPlayerApi.sendMessage(unityPlayerInstance, {
      gameObjectName: "FrontEndInteractionManager",
      gameObjectMethodName: "SetActiveFeature",
      value: JSON.stringify({ featureKey: "POLARIZATION" }),
    });
  };

  const handlePlayerLoadInit = (unityInstance: any) => {
    // TODO: refactor this way of setting the configuration for dynamically-created gameobjects in a way that's 
    // not dependant on a Timeout (might involve refactor here, and on the unityScript as well)
    setTimeout(() => setModelConfig(unityInstance, buildingID), 5000);
  };

  return {
    handlePlayerLoadInit,
    playerAssetsConfig,
    playerActions: { setGlassPanelsTintStatusFeature, setGlassPanelsPolarizationFeature, setHeatMapFeature },
  };
};

export default useHomeController;
